import { RequireStaff } from "@/components/RequireStaff";
import { CalendarView } from "@/components/calendar";

export default function AdminCalendar() {
  return (
    <RequireStaff>
      <CalendarView />
    </RequireStaff>
  );
}
